if (!customElements.get('klaviyo-form')) {
  customElements.define(
    'klaviyo-form',
    class KlaviyoForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('.klaviyo-form');
        this.successMessage = this.querySelector('.klaviyo-message .success');
        this.errorMessage = this.querySelector('.klaviyo-message .error');

        this.form.addEventListener('submit', this.handleSubmitForm.bind(this));
      }

      async handleSubmitForm(e) {
        e.preventDefault();
        const data = new FormData(e.target);

        if (this.successMessage) this.successMessage.style.display = 'none';
        if (this.errorMessage) this.errorMessage.style.display = 'none';

        try {
          const request = await fetch('https://a.klaviyo.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            body: data,
          });

          if (request.status === 200) {
            if (this.successMessage) {
              this.successMessage.style.display = 'flex';
            }
            this.form.reset();
          } else {
            if (this.errorMessage) {
              this.errorMessage.style.display = 'flex';
            }
          }
        } catch (error) {
          console.error(error);
          if (this.errorMessage) {
            this.errorMessage.style.display = 'flex';
          }
        }
      }
    }
  );
}
